import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var FilterIcon = createIcon({
  displayName: 'FilterIcon',
  path: /*#__PURE__*/React.createElement("path", {
    d: "M2 4.33203H20.6667M17.3333 10.9987H5.33333M8.66667 17.6654H14",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2.66667"
  })
});
//# sourceMappingURL=Filter.js.map